import React from 'react';
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import Home from './Home';
import Login from './Login';
import withAuthentication from './session/withAuthentication';
class StartPage extends React.Component {
  constructor() {
    super();
  }
  render() {
    return (
      <Router>
        <div>
          <Route path="/" component={Home} />
          <Route path="/login" component={Login} />
        </div>
      </Router>
    );
  }
}

export default withAuthentication(StartPage);


// WEBPACK FOOTER //
// ./src/StartPage.js